module.exports = __webpack_public_path__ + "static/media/dpl-app-scoring.ea0d31f5.png";